import { ArrowBackIos, ArrowForwardIos, NavigateNext } from '@mui/icons-material'
import { Box, Breadcrumbs, Button, Stack, Typography } from '@mui/material'
import { Link as MLink } from '@mui/material';
import React from 'react'
import { TimeStampToMonthDateYear } from '../../../../../helpers/time-formater'
import CustomLargeLabel from '../../../../../helpers/large-label';
import { Auth } from "../../../../../auth/auth";

import DownlaodCreditReport from './download-credit-report';
import { useRecoilState } from 'recoil';
import { profileState } from '../../../../../recoil/profile-atom';

export default function LoanCreditReportStatus({ creditData, handleCreditSubmit, handlePrevious, partnerInfoPath, creditPull }) {
    let [profileData, setProfileData] = useRecoilState(profileState);

    let generateText;

    if (creditData?.isPulled) {
        if (!creditData?.creditReportStatus) {
            generateText = `The credit report was pulled on ${TimeStampToMonthDateYear(creditData?.pullDate)} with qualifying credit score of ${creditData?.creditScore}.`
        } else {
            generateText = `Credit consent was given on ${TimeStampToMonthDateYear(creditData?.consentDate)}! ${profileData?.role !== 'Borrower' ? 'Credit report pull is unsuccessfull please contact Credco at (800) 637-2422. ' : 'Credit pull is failed please report to your loan officer. '}
                            You still can continue the application and submit.`
        }
    } else {
        generateText = profileData?.role === 'Broker' ? `The credit consent was given on ${TimeStampToMonthDateYear(creditData?.consentDate)}!` : `Broker has not given the permission to pull the credit report.`
    }

    return (
        <>
            <Stack direction={'column'} justifyContent={'space-between'} py={2} px={4} height={'inherit'} overflow={'auto'}>
                <Box>
                    <Typography variant='h3' mb={2} mt={2}>{'Credit Report'}</Typography>
                    <Typography variant='body1' mb={2} color={'#222222BF'}>
                        {generateText}
                    </Typography>
                    {creditData?.creditReferenceNumber && (profileData?.role !== 'Borrower' || (creditData?.creditReportStatus && creditData?.isPulled)) &&
                        <Typography variant='body1' mb={2} color={'#222222BF'}>
                            Credit Reference #: {creditData.creditReferenceNumber}
                        </Typography>
                    }

                    {Auth.hasAnyRole(['MLO', 'Broker', 'MLO Owner', 'MLP']) &&

                        <>

                            {(!creditData?.creditReportStatus && creditData?.isPulled) && <DownlaodCreditReport creditReportId={creditData.id} />}
                            < Button onClick={creditPull} variant='contained'>
                                {creditData?.isPulled ? 'Repull' : 'Pull Credit Report'}
                            </Button>
                        </>

                    }
                </Box>

                <Box maxWidth={{ xs: '100%', md: '50%' }} mt={2}>
                    <Stack direction={'row'} justifyContent={'space-between'}>
                        <Button onClick={handlePrevious} startIcon={<ArrowBackIos />}>
                            Previous
                        </Button>
                        <Button onClick={handleCreditSubmit} endIcon={<ArrowForwardIos />} >
                            Save and Next
                        </Button>
                    </Stack>
                </Box>
            </Stack >
        </>
    )
}
